import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ChangePasswordDialog from "./ChangePasswordDialog";
import { fetchWithAuth } from 'utils/fetchWithAuth';

export default function ChangePasswordPage() {
    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();

    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");

    const [mdpError, setMdpError] = useState("");
    const [mdpSuccess, setMdpSuccess] = useState("");
    const [mdpLoading, setMdpLoading] = useState(false);

    const handleChangePassword = async (e) => {
        e.preventDefault();
        setMdpError("");
        setMdpSuccess("");

        if (newPassword !== confirmNewPassword) {
            setMdpError("Les mots de passe ne correspondent pas");
            return;
        }

        setMdpLoading(true);

        try {
            const res = await fetchWithAuth(`${API_URL}/api/change-password/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    old_password: oldPassword,
                    new_password: newPassword
                }),
            });

            const data = await res.json();

            if (res.ok) {
                setMdpSuccess("Mot de passe changé !");
                setOldPassword("");
                setNewPassword("");
                setConfirmNewPassword("");

                setTimeout(() => {
                    navigate("/logout", { replace: true });
                }, 2000);

            } else {
                setMdpError(data.detail || "Erreur lors du changement de mot de passe");
            }

        } catch (err) {
            setMdpError("Erreur serveur");
        }

        setMdpLoading(false);
    };

    return (
        <div>
        <ChangePasswordDialog
            open={true}
            onClose={() => navigate("/logout")}
            oldPassword={oldPassword}
            setOldPassword={setOldPassword}
            newPassword={newPassword}
            setNewPassword={setNewPassword}
            confirmNewPassword={confirmNewPassword}
            setConfirmNewPassword={setConfirmNewPassword}
            mdpError={mdpError}
            mdpSuccess={mdpSuccess}
            mdpLoading={mdpLoading}
            handleChangePassword={handleChangePassword}
        />
        </div>
    );
}
